export default __webpack_public_path__ + "media/images/footer/visa-576e9c78b0e99c7b69186b1880455f23.svg";